import { ReactElement, ReactNode, useContext, useMemo, useState } from "react";
import CursorProvider, { CursorState } from "../../../providers/CursorProvider";
import { CursorComponent } from "../CursorComponent";
import bg_plasma_on from "url:../../assets/cursors/plz.gif";

interface PLZP
{
    offState: ReactNode;
    onState: ReactNode;
    startOn ?: boolean;
    onEnable ?: () => void;
    onDisable ?: () => void;
    stdOnClick ?: () => void;
    className ?: string;
    style ?: React.CSSProperties;
    id ?: string;
}

export function Plzma (props: PLZP) {
    const cursor = useContext(CursorProvider.context);
    const startOn = props.startOn !== undefined ? props.startOn : false;
    const [status, setStatus] = useState<boolean>(startOn);
    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};

    return <CursorComponent id={props.id} cursor={CursorState.PLZ} onClick={() => {
        if (cursor.plzchg == status)
        {
            if (status && props.stdOnClick !== undefined)
                props.stdOnClick();
            return;
        }
            
        const nowOn = !status;
        setStatus(nowOn);
        cursor.setPlzchg(!nowOn);

        if (nowOn && props.onEnable !== undefined)
            props.onEnable();
        if (!nowOn && props.onDisable !== undefined)
            props.onDisable();
    }} stdOnClick={() => {
        if (status && props.stdOnClick !== undefined)
            props.stdOnClick();
    }} className={className} style={style}>
        { status ? props.onState : props.offState }
    </CursorComponent>
}